<template>
  <div>
    <v-card @click="matchUs(item)" elevation="2" class="card">
      <v-card-text>
        <v-row dense class="flex-column">
          <v-row dense>
            <v-col>
              <v-avatar color="primary" size="50" class="mt-3">
                <v-img :src="item.avatar" rounded contain />
              </v-avatar>
            </v-col>
            <v-col>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-rating
                    v-on="on"
                    v-bind="attrs"
                    dense
                    background-color="orange lighten-3"
                    color="orange"
                    large
                    :value="item.rating"
                    readonly
                  />
                </template>
                <span class="text-h6"
                  >Avaliação geral: {{ item.rating }} / 5</span
                >
              </v-tooltip>
            </v-col>
          </v-row>
          <span class="text-h4 mt-3 gradientTitle">{{ item.name }}</span>
          <span class="text-h6 mt-2" v-if="item.hasCertificate"
            >Certificações:

            <span class="text-h6 gradientTitle">
              {{ item.certificates.join(",") }}
            </span>
          </span>

          <span class="text-h6"
            >Modalidade:<span class="text-h6">
              <span class="text-h6 gradientTitle">
                {{
                  item.plans.length > 0
                    ? displayFormat(item.plans[0].time)
                    : "A combinar"
                }}</span
              ></span
            ></span
          >
          <span class="text-h6"
            >Duração:
            <span class="text-h6 gradientTitle"
              >{{
                item.plans.length > 0
                  ? displayTime(item.plans[0].time)
                  : "A combinar"
              }}
            </span></span
          >
          <span class="text-h6"
            >Dia(s) da semana:
            <span class="text-h6 gradientTitle">
              {{ displayWeekDay }}</span
            ></span
          >
          <span class="text-h6"
            >Horário:
            <span class="text-h6 gradientTitle">
              A partir das {{ item.available[0].from }}h</span
            ></span
          >
        </v-row>
      </v-card-text>
      <v-card-actions
        ><span
          class="text-center success-600"
          style="background-clip: text; -webkit-text-fill-color: transparent"
          >R$:
          {{
            item.plans.length > 0
              ? formatPrice(item.plans[0].value)
              : "A combinar"
          }}</span
        >
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon x-small class="mr-3" v-on="on" v-bind="attrs">
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <span class="text-h6"
            >Valor de R$
            {{
              item.plans.length > 0
                ? formatPrice(item.plans[0].value)
                : "A combinar"
            }}
            cobrado pelo professor mensalmente</span
          >
        </v-tooltip>
      </v-card-actions>
    </v-card>
    <confirm-dialog
      ref="confirmDialog"
      :title="dialogTitle"
      :text="dialogText"
      :item="selected"
      :limit="limit"
      :content="dialogContent"
      @confirmed="requestJoin"
      @cancel="cancel"
    />
  </div>
</template>

<script>
export default {
  name: "MatchedPartnerCard",
  props: {
    item: {
      type: Object,
    },
    weekDay: {
      type: Number,
    },
    start: {
      type: String,
    },
    limit: {
      type: Number,
    },
  },
  computed: {
    displayWeekDay() {
      const days = new Set(this.item.available.map((i) => i.weekDay));
      const nomes = this.weekDaysItems
        .filter((dia) => days.has(String(dia.value)))
        .map((dia) => dia.text);

      return nomes.join(", ");
    },
  },
  data() {
    return {
      dialogTitle: "",
      dialogText: "",
      dialogContent: null,
      selected: null,
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
    };
  },
  methods: {
    matchUs(item) {
      this.selected = item;
      this.dialogTitle = `Enviar solicitação ao professor: ${item.name}`;
      this.dialogContent = item.available;
      this.dialogText = `Ao enviar a solicitação, o professor será notificado, após a confirmação sua entrada na turma na turma será automática.`;
      this.$refs.confirmDialog.open();
    },
    displayFormat(format) {
      switch (format) {
        case 1:
          return "Individual";
        case 2:
          return "Dupla";
        case 3:
          return "Trio";
        case 4:
          return "Quarteto";
      }
    },
    formatPrice(value) {
      return new Intl.NumberFormat("id", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(parseFloat(value).toFixed(2));
    },
    displayTime(time) {
      return time === 1 ? "60 minutos" : "90 minutos";
    },
    displayFrequency(frequency) {
      return `${frequency}x semana`;
    },

    requestJoin(item) {
      this.$emit("requestJoin", item);
    },
    cancel() {
      this.dialogTitle = "";
      this.dialogText = "";
      this.selected = null;
    },
  },
};
</script>

<style lang="css" scoped>
.gradientTitle {
  background: linear-gradient(to right, #e8276f, #9923cd);

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  animation: moveGradient 3s linear infinite;
}

.glowingText {
  animation: glowText 0.8 ease-in-out infinite alternate;
}

@keyframes moveGradient {
  0% {
    background-position: 50% 0;
  }
  50% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 0;
  }
}

.card {
  width: 100%;
  height: 450px;
  border-radius: 30px 15px 30px 15px;
  background-color: transparent;
  display: flex;
  flex-direction: column;
}

.text-h4,
.text-h6 {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.limit-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
